import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['row', 'total']
  static values = { countSelector: { type: String, default: '.js-cart-count' },
                    priceSelector: { type: String, default: '.js-cart-price' } }

  async change(event) {
    const input = event.target
    const response = await post(input.dataset.url, {
      body: {
        session_product: {
          student_code: input.dataset.session,
          product_id: input.dataset.product,
          quantity: input.value
        }
      },
      responseKind: 'json'
    })

    if (!response.ok) return

    if (parseInt(input.value, 10) === 0) input.closest('tr').remove()
    this.#refresh()
  }

  #refresh() {
    let total = 0
    let count = 0

    this.rowTargets.forEach((row) => {
      const price = parseFloat(row.querySelector('[data-cart-summary-target="price"]')?.textContent)
      const quantity = parseInt(row.querySelector('input')?.value, 10)
      if (isNaN(price) || isNaN(quantity)) return

      total += price * quantity
      count += quantity
    })

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = `Total : ${total.toFixed(2)} €`
    }
    document.querySelectorAll(this.countSelectorValue).forEach((el) => { el.textContent = count })
    document.querySelectorAll(this.priceSelectorValue).forEach((el) => { el.textContent = total.toFixed(2) })
  }
}
